import { Container } from './styles';
import { appVersion } from '../../helpers/environment';

const Footer = () => {
  return (
    <Container>Mapeador de Atributos v{appVersion}</Container>
  );
};

export default Footer;